import(/* webpackMode: "eager" */ "/home/ubuntu/user-b2c/src/app/promotion/component/CampaignComponent.jsx");
import(/* webpackMode: "eager" */ "/home/ubuntu/user-b2c/src/app/promotion/component/PromotionProduct.jsx")